import * as yup from 'yup';

export const reset_password_schema = {
    password: '',
    confirm_password: '',
};

export const reset_password_validation_schema = yup.object().shape({
    password: yup
        .string()
        .required('password_required_validation')
        .min(6, "password_length_validation")
        .matches(/^\S*$/, 'enter_valid_password')
        .matches(/[a-z]/, "password_must_have_lowercase")
        .matches(/[A-Z]/, "password_must_have_uppercase")
        .matches(/[0-9]/, "password_must_have_number")
        // .min(8, 'password_length_validation')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, "password_must_have_special"),
    confirm_password: yup.string().oneOf([yup.ref('password')], 'same_password_validation'),
});
